module.exports = __webpack_public_path__ + "static/media/overpass-extralight.c5791995.woff2";